export enum ApiEndpoint {
	Login = "/login",
	Ping = "/ping",
	Clients = "/clients",
	Settings = "/settings",
	Areas = "/areas",
	Meals = "/settings/meals",
	Tables = "/tables",
	Reservations = "/reservations",
	Inquiries = "/inquiries",
	ReservationInquiries = "/reservation-inquiries",
	OccupiedDays = "/occupied-days",
	Availabilities = "/availabilities",
	Payments = "/payments",
	OccupancyPlan = "/files/occupancy-plan",
	OccupancyList = "/files/occupancy-list",
	OccupancyListExcel = "/files/occupancy-list-xlsx",
	PreorderedMeals = "/files/preordered-meals"
}

export enum ApiSubresourceEndpoint {
	InquiryMessages = "messages",
	SettingsSignatures = "signatures"
}
